import { put, call, takeEvery } from "redux-saga/effects";
import { generalErrorHandler } from "../rootSaga";
import { API, links } from "@http";
import { sharedSessionTitleHandler } from "@utils";
import {
  setSessionsList,
  setSelectedSession,
  setSessionAccounts,
  getSessionAccounts,
  pullListSessions,
} from "./actions";
import {
  startLoading,
  stopLoading,
  stopOpenAccountLookup,
} from "../UIState/actions";
import { replace } from "connected-react-router";

import { getEmailsForSendPin, getEmailSources } from "../emailFlow/actions";

import { SessionState, SessionsAction, SessionDataType } from "./types";
import { getEmailList, getMainSources } from "../mainFlow/actions";

const HOME_LINK = "/sessions/verify-pin/";

function* pullSessionList({ payload }: SessionsAction) {
  try {
    const { data } = yield call(API, links.session.list);

    const sharedSessionsCount = data.reduce(
      (accumulator: number, currentValue: any) =>
        currentValue.state === "NEW_SHARED_SESSION"
          ? accumulator + 1
          : accumulator,
      0
    );
    sharedSessionTitleHandler(sharedSessionsCount);

    yield put(setSessionsList(data));
    if (payload.isOpenAccountLookup) yield put(stopOpenAccountLookup());
  } catch (error) {
    yield generalErrorHandler(error);
  }
}

function* getSessionDetailsSaga({ payload }: SessionsAction) {
  try {
    const response = yield call(API, links.session.details(payload));
    yield put(setSelectedSession(response.data));
    switch (response.data.state) {
      case SessionState.MAIN_FLOW_CONFIRM_EMAIL:
        yield put(getEmailList(response.data.sessionId));
        break;
      case SessionState.EMAIL_FLOW_SEND_PIN:
        yield put(getEmailsForSendPin(response.data.sessionId));
        break;
      case SessionState.EMAIL_FLOW_VERIFY_PIN:
        yield put(getEmailsForSendPin(response.data.sessionId));
        break;
      case SessionState.EMAIL_FLOW_CHOOSE_SOURCE:
        yield put(getEmailSources(response.data.sessionId));
        break;

      case SessionState.MAIN_FLOW_CHOOSE_SOURCE:
        yield put(getMainSources(response.data.sessionId));
        break;
      case SessionState.VERIFIED:
        yield put(getSessionAccounts(response.data.sessionId));
        break;
    }
  } catch (error) {
    yield generalErrorHandler(error);
  }
}

function* getSessionAccountsSaga({ payload }: SessionsAction) {
  try {
    yield put(startLoading());
    const response = yield call(API, links.session.accounts(payload));
    const viewed = response.data.accounts.map((account: any) => ({
      [account.accountName]: false,
    }));

    yield put(setSessionAccounts({ ...response.data, viewed }));
  } catch (error) {
    yield generalErrorHandler(error);
  } finally {
    yield put(stopLoading());
  }
}

function* sessionTickerSaga({ payload }: SessionsAction) {
  try {
    yield call(API.post, links.session.sessionTick(payload));
  } catch (error) {
    yield generalErrorHandler(error);
  }
}

function* removeSessionSaga({ payload }: SessionsAction) {
  try {
    yield call(API, links.session.remove(payload));
    yield put(pullListSessions());
    yield put(replace(HOME_LINK));
  } catch (error) {
    yield generalErrorHandler(error);
  }
}

export default function* sessionsSaga() {
  yield takeEvery(SessionDataType.PULL_SESSIONS, pullSessionList);
  yield takeEvery(SessionDataType.GET_SESSION_BY_ID, getSessionDetailsSaga);
  yield takeEvery(SessionDataType.GET_ACCOUNTS, getSessionAccountsSaga);
  yield takeEvery(SessionDataType.SESSION_TICK, sessionTickerSaga);
  yield takeEvery(SessionDataType.REMOVE_SESSION, removeSessionSaga);
}
